module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"static-page-content-not-found-error":"Aucune page n\u0027a été trouvée pour cette url dans cette langue."},"en":{"static-page-content-not-found-error":"No page has been found for this url in this language."}}')
  delete Component.options._Ctor
}
